

export const AlertIcon: React.FC<({ size?: number })> = ({ size }) => (
    <svg
        width={size ?? 28}
        height={size ?? 28}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: size ?? 28, height: size ?? 28 }}
    >
        <path d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z" fill="#E11F1D" />
        <path d="M7.85547 2.36874L7.71484 8.38632H6.50781L6.36133 2.36874H7.85547ZM6.32031 10.232C6.32031 10.0172 6.39062 9.83749 6.53125 9.69296C6.67578 9.54453 6.875 9.47031 7.12891 9.47031C7.37891 9.47031 7.57617 9.54453 7.7207 9.69296C7.86523 9.83749 7.9375 10.0172 7.9375 10.232C7.9375 10.4391 7.86523 10.6168 7.7207 10.7652C7.57617 10.9098 7.37891 10.982 7.12891 10.982C6.875 10.982 6.67578 10.9098 6.53125 10.7652C6.39062 10.6168 6.32031 10.4391 6.32031 10.232Z" fill="white" />
    </svg>
);
